import Tasks from './views/Tasks'
import Task from './views/Task'
import TaskForm from './views/TaskForm'
import TaskLogs from './views/TaskLogs'

export default { 
    routes: [
        {
            path: '/tasks',
            name: 'Tasks',
            component: Tasks,
            meta: { toolbars: ['Search'] }
        },
        {
            path: '/tasks/:taskid',
            name: 'Task',
            components: { right: Task, default: Tasks },
            meta: { toolbars: ['Search'] }
        },
        /*
        {
            path: '/tasks/:projectid?',
            name: 'Tasks',
            component: Tasks,
            meta: { toolbars: ['Search'] }
        },
        {
            path: '/tasks/:projectid?/create',
            name: 'TaskCreate',
            components: { right: TaskForm, default: Tasks },
            meta: { toolbars: ['Search'] }
        },
        {
            path: '/tasks/:projectid/:taskid(\\d+)',
            name: 'Task',
            components: { right: Task, default: Tasks },
            meta: { toolbars: ['Search'] }
        },
        {
            path: '/tasks/:projectid/:taskid/edit',
            name: 'TaskEdit',
            components: { right: TaskForm, default: Tasks },
            meta: { toolbars: ['Search'] }
        },
        {
            path: '/tasks/:projectid/:taskid/logs',
            name: 'TaskLogs',
            components: { right: TaskLogs, default: Tasks },
            meta: { toolbars: ['Search'] }
        }
        */
    ]  
}


// WEBPACK FOOTER //
// ./src/modules/tasks/routes.js